const AUDIO_CODECS = [
    'audio/webm;codecs=opus',
    'audio/webm',
    'audio/ogg;codecs=opus',
    'audio/ogg',
    'audio/mp4',
    'audio/aac',
];

const DEFAULT_AUDIO_CODEC = AUDIO_CODECS[0];

let isMediaRecorderSupportedMemo: boolean | undefined;
export const isMediaRecorderSupported = () => {
    if (typeof isMediaRecorderSupportedMemo !== 'undefined') {
        return isMediaRecorderSupportedMemo;
    }
    isMediaRecorderSupportedMemo =
        typeof MediaRecorder !== 'undefined' &&
        typeof MediaRecorder.isTypeSupported !== 'undefined' &&
        AUDIO_CODECS.some(MediaRecorder.isTypeSupported);
    return isMediaRecorderSupportedMemo;
};

export function getSupportedMediaSupportedAudioCodec(): string {
    if (!isMediaRecorderSupported()) {
        return DEFAULT_AUDIO_CODEC;
    }

    for (const mimeType of AUDIO_CODECS) {
        if (MediaRecorder.isTypeSupported(mimeType)) {
            return mimeType;
        }
    }
    return DEFAULT_AUDIO_CODEC;
}
